import {
  pdfActions,
  pdfSelectors,
  readerActions,
  readerSelectors,
  useAppDispatch,
} from '@readcloud/state';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { EPUBSettings } from './EPUBSettings/EPUBSettings';

interface IConnectedEPUBSettingsProps {}

export const ConnectedEPUBSettings: React.FunctionComponent<
  IConnectedEPUBSettingsProps
> = (props) => {
  const readerData = useSelector(readerSelectors.getReaderData);

  const pdfData = useSelector(pdfSelectors.getPDFData);

  const dispatch = useAppDispatch();
  return (
    <EPUBSettings
      theme={readerData?.viewState?.epubMode}
      onEnableWalkthrough={() => {}}
      font={readerData?.viewState?.epubFont}
      onFontChange={(font: string) =>
        dispatch(
          readerActions.asyncActions.updateViewState({
            epubFont: font,
          })
        )
      }
      fontSize={readerData?.viewState?.epubFontSize}
      onFontSizeChange={(fontSize: number) =>
        dispatch(
          readerActions.asyncActions.updateViewState({
            epubFontSize: fontSize,
          })
        )
      }
      onThemeChange={(theme: string) =>
        dispatch(
          readerActions.asyncActions.updateViewState({
            epubMode: theme,
          })
        )
      }
      darkMode={pdfData.settings.darkMode}
      onDarkModeChange={(darkMode: boolean) =>
        dispatch(
          pdfActions.updatePDFSettings({
            darkMode,
          })
        )
      }
    />
  );
};
